import {Component} from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import Loader from "../Loader/Loader";
import {fetchNewsById} from "../../store/actions/news";
import {URL_BACKEND} from "../../utils/const";
import {replaceImageSrc} from "../../utils/utils";
import {ReactTitle} from "react-meta-tags";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation} from "swiper";

import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import ImagePopup from "../Popups/ImagePopup";

SwiperCore.use([Navigation])

class LongNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imagePopupLink: ""
        }
    }

    componentDidMount() {
        this.props.fetchNewsById(this.props.match.params.name);
    }

    getTags = (tags) => {
        if (tags) {
            const arrayTags = tags.split(",");
            return arrayTags.map((item) => {
                return (
                    <Link
                        key={item}
                        to={`/news/?tag=${item}`}
                        className="label label-info"
                    >
                        {item}
                    </Link>
                );
            });
        }
        return null;
    };

    closePopup = () => {
        this.setState({imagePopupLink: ""})
    }


    render() {

        return (
            <>
                <ReactTitle title={this.props.itemNews.title}/>

                <br/>
                {this.props.loadingNews ? (
                    <Loader/>
                ) : (
                    <>
                        <ul className="breadcrumb">
                            <li>
                                <Link to="/">Главная</Link>
                            </li>
                            <li>
                                <Link to="/news">Новости</Link>
                            </li>
                            <li className="active">{this.props.itemNews.title}</li>
                        </ul>

                        <div className="inside-wrapper">
                            <p className="news-inside-tags">
                                {this.getTags(this.props.itemNews.tags)}
                            </p>

                            <h1 className="news-inside-title">{this.props.itemNews.title}</h1>

                            {this.props.itemNews.img_small && (
                                <img
                                    className="news-inside-title-image"
                                    src={URL_BACKEND + this.props.itemNews.img_small}
                                    alt={this.props.itemNews.title}
                                />
                            )}


                            {this.props.itemNews.images &&
                                <Swiper navigation={true}
                                        slidesPerView={1}
                                        spaceBetween={30}
                                        centeredSlides={true}
                                        breakpoints={{
                                            997: {
                                                slidesPerView: 2
                                            }
                                        }}
                                >
                                    {this.props.itemNews.images.split(";").map((img) => {
                                        return <SwiperSlide key={img}><img
                                            onClick={() => this.setState({imagePopupLink: URL_BACKEND + img})}
                                            alt={this.props.itemNews.title} src={URL_BACKEND + img}/></SwiperSlide>
                                    })}
                                </Swiper>
                            }

                            <div className="news-inside-text">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: replaceImageSrc(this.props.itemNews.text_all),
                                    }}
                                />
                                <Link to="/pages/to-help">
                                    <div className="btn btn-primary choose-donate-btn">
                                        Способы пожертвования
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <ImagePopup closePopup={this.closePopup} cardLink={this.state.imagePopupLink}/>
                    </>
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        itemNews: state.news.itemNews || {},
        loadingNews: state.news.loading,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchNewsById: (id) => dispatch(fetchNewsById(id)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LongNews);
